import { put, call, takeLatest } from "redux-saga/effects";

import {
  MAP_CANDIDATE,
  GET_MAPPED_CANDIDATE_DETAILS,
  GET_MAPPED_CANDIDATES,
  GET_MAPPED_CANDIDATES_COUNT,
  GET_CANDIDATE_STATUS,
  GET_CANDIDATE_ACTIVITY_FEED,
} from "./actionTypes";
import {
  mapCandidateSuccess,
  mapCandidateFail,
  getMappedCandidateDetailsSuccess,
  getMappedCandidateDetailsFail,
  getMappedCandidatesSuccess,
  getMappedCandidatesFail,
  getMappedCandidatesCountSuccess,
  getMappedCandidatesCountFail,
  getCandidateStatusSuccess,
  getCandidateStatusFail,
  getCandidateActivityFeedSuccess,
  getCandidateActivityFeedFail,
} from "./actions";

import { getCall, postCall } from "../../../helpers/fakebackend_helper";

//restapi end point
import * as constClass from "../../../common/constant/constantURL";
import { showErrorMessage } from "../../actions";

function* mapCandidateF({ payload: { data } }) {
  try {
    let url = constClass.REST_API_MAP_CANDIDATE;
    let responsJSON = yield call(postCall, decodeURIComponent(url), data);
    yield put(mapCandidateSuccess(responsJSON));
  } catch (error) {
    yield put(mapCandidateFail(error));
  }
}

function* getMappedCandidateDetailsF({ payload }) {
  try {
    const { jobId, candidateId } = payload;

    let responsJSON = yield call(
      getCall,
      constClass.REST_API_RECRUITMENT + "/candidate",
      { jobId, candidateId },
    );

    yield put(getMappedCandidateDetailsSuccess(responsJSON));
  } catch (error) {
    yield put(getMappedCandidateDetailsFail(error));
    if (error?.message) {
      yield put(showErrorMessage(error.message));
    }
  }
}

function* getMappedCandidatesF({ payload: { data } }) {
  try {
    let url =
      constClass.REST_API_GET_MAPPED_CANDIDATES +
      `?jobId=${data.payload.jobId}&candidateId=${data.payload.candidateId}`;
    let responsJSON = yield call(postCall, url, data);
    yield put(getMappedCandidatesSuccess(responsJSON));
  } catch (error) {
    yield put(getMappedCandidatesFail(error));
  }
}

function* getMappedCandidatesCountF({ payload: { data } }) {
  try {
    let url =
      constClass.REST_API_GET_MAPPED_CANDIDATES_COUNT +
      `?jobId=${data.payload.jobId}&candidateId=${data.payload.candidateId}`;
    let responsJSON = yield call(postCall, url, data);
    yield put(getMappedCandidatesCountSuccess(responsJSON));
  } catch (error) {
    yield put(getMappedCandidatesCountFail(error));
  }
}

function* getCandiidateStatusHandler({ payload }) {
  try {
    const { jobId, candidateId } = payload;

    let responsJSON = yield call(
      getCall,
      constClass.REST_API_RECRUITMENT + "/status",
      { jobId, candidateId },
    );

    yield put(getCandidateStatusSuccess(responsJSON));
  } catch (error) {
    yield put(getCandidateStatusFail(error));
    if (error?.message) {
      yield put(showErrorMessage(error.message));
    }
  }
}

function* getCandidateActivityFeedF({ payload }) {
  try {
    const { jobId, candidateId } = payload;

    let responsJSON = yield call(getCall, "process/timeline/activity-feed", {
      jobId,
      candidateId,
    });

    yield put(getCandidateActivityFeedSuccess(responsJSON));
  } catch (error) {
    yield put(getCandidateActivityFeedFail(error));
  }
}

function* mappingSaga() {
  yield takeLatest(MAP_CANDIDATE, mapCandidateF);
  yield takeLatest(GET_MAPPED_CANDIDATE_DETAILS, getMappedCandidateDetailsF);
  yield takeLatest(GET_MAPPED_CANDIDATES, getMappedCandidatesF);
  yield takeLatest(GET_MAPPED_CANDIDATES_COUNT, getMappedCandidatesCountF);
  yield takeLatest(GET_CANDIDATE_STATUS, getCandiidateStatusHandler);
  yield takeLatest(GET_CANDIDATE_ACTIVITY_FEED, getCandidateActivityFeedF);
}

export default mappingSaga;
